import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 3a.7.7 0 0 1 .633.4l2.438 5.145 5.32.703a.7.7 0 0 1 .423 1.168l-3.808 4.125 1.05 5.63a.7.7 0 0 1-1.002.754L12 18.384l-5.054 2.541a.7.7 0 0 1-1.002-.753l1.05-5.631-3.808-4.125a.7.7 0 0 1 .422-1.168l5.321-.703L11.367 3.4A.7.7 0 0 1 12 3m0 2.334L10.031 9.49a.7.7 0 0 1-.54.394l-4.36.576 3.13 3.39a.7.7 0 0 1 .174.603l-.856 4.588 4.107-2.065a.7.7 0 0 1 .629 0l4.106 2.065-.856-4.588a.7.7 0 0 1 .174-.603l3.13-3.39-4.36-.576a.7.7 0 0 1-.54-.394z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=StarOutlineIcon24.js.map